import React from 'react';

function NotFound() {
    return (
        <div>
            <h1>Error 404</h1>
            <p>La página que estás buscando no existe.</p>
        </div>
    );
}

export default NotFound;
